@if (_errorMessage !== null) {
  <div class="c-red" role="alert" aria-live="assertive">
    {{ _errorMessage }}
  </div>
}